// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import "./Style.css";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
// import axios from 'axios';

export default function EditCompany({
    showEdit,
    closeModal,
    refreshPage,
    companyDetails,
}) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [customer, setCustomer] = useState([]);
    const [formData, setFormData] = useState({
        company_name: "",
        location: "",
        contact_person_phone: "",
        country: "",
        state: "",
        city: "",
        email: "",
        area: "",
        industry: "",
        website: "",
        address: "",
    });

    const resetForm = () => {
        setFormData({
            company_name: "",
            location: "",
            contact_person_phone: "",
            country: "",
            state: "",
            city: "",
            email: "",
            area: "",
            industry: "",
            website: "",
            address: "",
        });
        setValidationError({});
    };


    useEffect(() => {
        if (companyDetails) {
            setFormData({
                company_name: companyDetails?.company_name || "",
                location: companyDetails?.location || "",
                contact_person_phone: companyDetails?.contact_person_phone || "", 
                country: companyDetails?.country || "", 
                state: companyDetails?.state || "", 
                city: companyDetails?.city || "", 
                email: companyDetails?.email || "", 
                area: companyDetails?.area || "", 
                industry: companyDetails?.industry || "", 
                website: companyDetails?.website || "", 
                address: companyDetails?.address || "", 

                // role: userDetails.roles[0]?.name || "",
                // user_type_name: userDetails.userType?.user_type_name || "",
            });
            // if (userDetails.roles.length > 0) {
            //   setSelectedRole(userDetails.roles[0].id);
            //   setSelectedUser(userDetails.user_type_id);

            // }
        }
    }, [companyDetails]);

    const handleChange = (e) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [e.target.name]: e.target.value,
        }));
    };

    const handleClose = () => {
        // resetForm();
        closeModal();
    };

    //   const handleClose = () => {
    //     resetForm();
    //     closeModal();
    //   }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Extract the role ID from the selectedRole state
            const response = await axiosInstance.post(
                `/user/company/company-details`,
                {
                    id: companyDetails.company_id,
                    company_name: formData.company_name ,
                    location: formData.location ,
                    contact_person_phone: formData.contact_person_phone ,
                    country: formData.country ,
                    state: formData.state ,
                    city: formData.city ,
                    email: formData.email ,
                    area: formData.area ,
                    industry: formData.industry ,
                    website: formData.website ,
                    address: formData.address , 

                }
            );

            if (response.data.success) {
                // Handle successful response, e.g., show success message
                toast.success("Customer updated successfully!");
                refreshPage();
                handleClose(); // Close the modal
            } else {
                // Handle errors, e.g., show error messages
                console.error("Update failed:", response.data.message);
            }
        } catch (error) {
            console.error("An error occurred while updating the user:", error);
            toast.error("Failed to Update user.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="CreateCSP">
            <Modal show={showEdit} onHide={handleClose} dialogClassName="modal-md">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Company Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* <Form.Label>Name</Form.Label> */}
                        <Form.Group className="mb-3" controlId="formBasicname">
                            <div>
                                <h6>Compamy Name</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="company_name"
                                value={formData.company_name}
                                onChange={handleChange}
                            />
                            {validationError.company_name && (
                                <small className="text-danger my-1">
                                    {" "}
                                    {validationError.company_name[0]}{" "}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicname">
                            <div>
                                <h6>Contact Person Phone</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="contact_person_phone"
                                value={formData.contact_person_phone}
                                onChange={handleChange}
                            />
                            {validationError.contact_person_phone && (
                                <small className="text-danger my-1">
                                    {" "}
                                    {validationError.contact_person_phone[0]}{" "}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formEmail">
                            <div>
                                <h6>Company Email</h6>
                            </div>
                            <Form.Control
                                type="email"
                                placeholder="Enter..."
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                readOnly
                                style={{ backgroundColor: "#f0f0f0", color: "#6c757d" }}
                            />
                            {validationError.email && (
                                <small className="text-danger my-1">
                                    {" "}
                                    {validationError.email[0]}{" "}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                            <div>
                                <h6>Country</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                            />
                            {validationError.country && (
                                <small className="text-danger my-1">
                                    {" "}
                                    {validationError.country[0]}{" "}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                            <div>
                                <h6>State</h6>
                            </div>
                            <Form.Control
                                type="state"
                                placeholder="Enter..."
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                            />
                            {validationError.state && (
                                <small className="text-danger my-1">
                                    {" "}
                                    {validationError.state[0]}{" "}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>City</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                            />
                            {validationError.city && (
                                <small className="text-danger my-1">
                                    {validationError.city[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>address</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                            />
                            {validationError.address && (
                                <small className="text-danger my-1">
                                    {validationError.address[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>Area</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="area"
                                value={formData.area}
                                onChange={handleChange}
                            />
                            {validationError.area && (
                                <small className="text-danger my-1">
                                    {validationError.area[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <div>
                                <h6>Industry</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="industry"
                                value={formData.industry}
                                onChange={handleChange}
                            />
                            {validationError.industry && (
                                <small className="text-danger my-1">
                                    {validationError.industry[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                            <div>
                                <h6>Website</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="website"
                                value={formData.website}
                                onChange={handleChange}
                            />
                            {validationError.website && (
                                <small className="text-danger my-1">
                                {" "}
                                {validationError.website[0]}{" "}
                                </small>
                            )}
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button variant="link" onClick={handleClose}>
              Close
            </Button> */}
                        <Button
                            className=""
                            style={{ backgroundColor: "#c4281b", color: "#fff" }}
                            type="submit"
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            {/* <ToastContainer /> */}
        </div>
    );
}
